import React, { ChangeEvent } from 'react';
import Radio from '@material-ui/core/Radio';
import { makeStyles } from '@material-ui/core/styles';

import { colors } from 'src/themes/colors';

interface Props {
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  color?: 'primary' | 'secondary' | 'default';
}

const useStyles = makeStyles({
  mainColor: {
    color: colors.gray16,
  },
  root: {
    padding: '7px 9px',
  },
});

const MHRadio: React.FC<Props> = ({ checked, onChange, color }) => {
  const classes = useStyles();

  return (
    <Radio
      color={color}
      checked={checked}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e)}
      classes={{ colorPrimary: classes.mainColor, root: classes.root }}
      size="small"
    />
  );
};

export default MHRadio;
